module.exports = __webpack_public_path__ + "img/ch16_19_问答赛登台.975a320f.jpg";